import { Check } from "lucide-react";
import { Reveal } from "../landing/Reveal";
import { scrollToId } from "../landing/Navbar";

const PLANS = [
  {
    name: "Free",
    price: "₹0",
    per: "forever",
    tagline: "For every student",
    features: ["Students", "Communities", "Learning Access"],
    cta: "Start Free",
    featured: false,
  },
  {
    name: "Premium",
    price: "₹99",
    per: "/month",
    tagline: "For power hustlers",
    features: ["Rewards", "AI Features", "Exclusive Content"],
    cta: "Go Premium",
    featured: true,
  },
  {
    name: "Business",
    price: "Custom",
    per: "pricing",
    tagline: "For the ecosystem pros",
    features: ["Recruiters", "Stores", "Chefs", "Farmers"],
    cta: "Talk to Sales",
    featured: false,
  },
];

export const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="relative overflow-hidden py-24 sm:py-32">
    <div aria-hidden="true" className="absolute -left-40 top-24 h-[400px] w-[400px] rounded-full bg-[#635BFF]/10 blur-[150px]" />
    <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#00D26A]">
          Pricing
        </p>
        <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Free to belong. ₹99 to supercharge.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {PLANS.map((p, i) => (
          <Reveal key={p.name} delay={0.08 * i} className="h-full">
            <div
              data-testid={`pricing-${p.name.toLowerCase()}`}
              className={`relative flex h-full flex-col rounded-3xl p-8 backdrop-blur-xl transition-transform duration-300 hover:-translate-y-1.5 ${
                p.featured
                  ? "border border-transparent bg-[#111827] [background:linear-gradient(#111827,#111827)_padding-box,linear-gradient(135deg,#635BFF,#00D26A)_border-box]"
                  : "border border-white/10 bg-[#111827]/80"
              }`}
            >
              {p.featured && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 rounded-full bg-gradient-to-r from-[#635BFF] to-[#00D26A] px-4 py-1 font-jbmono text-[10px] font-bold uppercase tracking-widest text-white">
                  Most Popular
                </span>
              )}
              <p className="font-jbmono text-[11px] uppercase tracking-[0.25em] text-slate-500">
                {p.tagline}
              </p>
              <h3 className="mt-2 font-display text-2xl font-extrabold text-white">{p.name}</h3>
              <p className="mt-4">
                <span className="font-display text-5xl font-black tracking-tight text-white">{p.price}</span>
                <span className="ml-1.5 font-jbmono text-xs text-slate-500">{p.per}</span>
              </p>
              <ul className="mt-7 flex-1 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-center gap-2.5 text-sm text-slate-300">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#00D26A]/15">
                      <Check className="h-3 w-3 text-[#00D26A]" />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`pricing-cta-${p.name.toLowerCase()}`}
                onClick={scrollToId("#claim")}
                className={`mt-8 w-full rounded-full py-3.5 font-display text-xs font-bold uppercase tracking-wider transition-colors ${
                  p.featured
                    ? "glow-btn-z bg-gradient-to-r from-[#635BFF] to-[#00D26A] text-white"
                    : "border border-white/15 bg-white/5 text-slate-200 hover:border-[#635BFF]/60 hover:text-white"
                }`}
              >
                {p.cta}
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
